import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { mainnet, sepolia} from "@reown/appkit/networks";
import { createAppKit } from "@reown/appkit";
import { http } from "viem";

export const projectId = "81905285a085515018c8c52c27153096";

if (!projectId) {
  throw new Error("Project ID is not defined");
}

export const networks = [sepolia];

export const wagmiAdapter = new WagmiAdapter({
  ssr: true,
  projectId,
  networks,
  transports: {
    [sepolia.id]: http(
      "https://eth-sepolia.g.alchemy.com/v2/waIrO9d9eJIg7g3Ta-fJN",
    ),
  },
});

const metadata = {
  name: "Escrow App",
  description: "Decentralized Escrow Application",
  url: "https://secrown.io", // origin must match your domain & subdomain
  icons: ["https://avatars.githubusercontent.com/u/179229932"],
};

const modal = createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks: [sepolia],
  defaultNetwork: mainnet,
  metadata: metadata,
  features: {
    analytics: true, // Optional - defaults to your Cloud configuration
  },
});
export { modal };
export const config = wagmiAdapter.wagmiConfig;
